
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../environments/environment";
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";
import { Block } from "../models/block.model";
import { TextBlockDetails } from "../models/text-block-details.model";
import { ImageBlockDetails } from "../models/image-block-details.model";
import { BarcodeBlockDetails } from "../models/barcode-block-details.model";

@Injectable({
    providedIn: 'root'
})

export class BlockCreatorService {

    public blockList: Block[] = [
    ];

    public rekbotID = 0

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private router: Router
    ) {

        console.log("construct", this.blockList)
    }

    getRekbotId() {
        return this.rekbotID
    }

    setRekbotId(rekId:number) {
        this.rekbotID =  rekId;
    }


    addBlock(
        rekbotID: number, 
        blockType: string, 
        blockName: string, 
        blockDetails?:TextBlockDetails | ImageBlockDetails | BarcodeBlockDetails) {

        let newBlock = new Block(
            0,
            rekbotID,
            blockName,
            blockType,
            blockDetails
        );

        //this.blockList.push(newBlock);

        const endpoint = environment.apiUrl + "/api/blocks";

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }

        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.post(
            endpoint, 
            newBlock,
            {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            })

    }

    updateBlock( block: Block | undefined, blockDetails: TextBlockDetails  | ImageBlockDetails | BarcodeBlockDetails | undefined) {

        let params = {
            block: block,
            blockDetails: blockDetails
        }

        console.log("updateBlock", block);

        if(block?.id) {
            const endpoint = environment.apiUrl + "/api/blocks/" + block?.id;

            if(this.authService.getToken().length == 0) {
                this.router.navigate(['/']);
            }
    
            const bearerToken = "Bearer " + this.authService.getToken()
            return this.http.put(
                endpoint, 
                params,
                {
                    headers: new HttpHeaders().set("Authorization", bearerToken)
                });
        }
        return null

    }


    removeBlock(block: string) {
        /*const itemIndex = this.blockList.indexOf(block);

        this.blockList = this.blockList.filter((item) => {
            return item !== block;
        });*/
    }

    getList() {
        return this.blockList;
    }

    fetchList(rekbotID: number) {
        const endpoint = environment.apiUrl + "/api/blocks/" + rekbotID;
        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(
            endpoint, 
            {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            });

    }

    getBlock() {
        return this.blockList.join(";")
    }

    clearList() {
        this.blockList = []
    }

    attachList(fetchedList: Block[]) {
        this.blockList = fetchedList;
    }

}